// Loads the Google Maps API - Fires the callback function when the API is loaded  
export class MapLoader {
    constructor(private apiKey: string, private lang: string) {}
  
    load(callback: () => void) {
      const script = document.createElement("script");
      script.src = `https://maps.googleapis.com/maps/api/js?key=${this.apiKey}&language=${this.lang}&callback=initMap`;
      script.async = true;
      script.defer = true;
      (window as any).initMap = callback;
      document.head.appendChild(script);
    }
  }
  